// extracted by mini-css-extract-plugin
export default {"showDetailText":"showDetailText-FS4qQs","verticalAlignMiddle":"verticalAlignMiddle-iYbk0g"};